import { useRequest } from "ahooks"
import { App, Button, message } from "antd"
import * as fileApi from '@/api/file'
import { useTranslation } from 'react-i18next';
const DemoButton = () => {
    const { modal } = App.useApp();
    const { t } = useTranslation('common');
    const { loading, run } = useRequest(fileApi.getDemoIntialization, {
        manual: true,
        onSuccess: (res) => {
            if (res?.ok) {
                if (res?.data?.length > 0) {
                    modal.confirm({
                        title: t('demo_button.warning_title'),
                        content: t('demo_button.override_content'),
                        okText: t('demo_button.override'),
                        closable: true,
                        onOk: async() => {
                            await run(true)
                        }
                    })
                }
                message.success(t('demo_button.success'))
            } else {
                message.error(t('demo_button.failed'))
            }
        }
    })

    return <>
        <Button size='large' loading={loading} onClick={()=>run()}>{t('editor_tabs_placeholder.demo_button')}</Button>
    </>
}

export default DemoButton